// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentMetadataCommon, ContentId_QUICKWIN, QuickWinType, ContentMetadata_QUICKWIN } from "../schema";
import { serialize_ContentMetadataCommon_internal, deserialize_ContentMetadataCommon_internal } from "./ContentMetadataCommon";
import { serialize_ContentId_QUICKWIN_internal, deserialize_ContentId_QUICKWIN_internal } from "./ContentId_QUICKWIN";
import { serialize_QuickWinType_internal, deserialize_QuickWinType_internal } from "./QuickWinType";

export function serialize_ContentMetadata_QUICKWIN_internal(value: ContentMetadata_QUICKWIN): unknown {
  return ((value: { common: ContentMetadataCommon; contentId: ContentId_QUICKWIN; contentType: "QUICKWIN"; dataId: number; modifiedAt: DateTime<true>; quickWinType: QuickWinType }): unknown => {
    return {
      common: ((value: ContentMetadataCommon): unknown => {
        return serialize_ContentMetadataCommon_internal(value);
      })(value["common"]),
      contentId: ((value: ContentId_QUICKWIN): unknown => {
        return serialize_ContentId_QUICKWIN_internal(value);
      })(value["contentId"]),
      contentType: ((value: "QUICKWIN"): unknown => {
        return value;
      })(value["contentType"]),
      dataId: ((value: number): unknown => {
        return value;
      })(value["dataId"]),
      modifiedAt: ((value: DateTime<true>): unknown => {
        return value.toMillis();
      })(value["modifiedAt"]),
      quickWinType: ((value: QuickWinType): unknown => {
        return serialize_QuickWinType_internal(value);
      })(value["quickWinType"]),
    };
  })(value);
}
export function serialize_ContentMetadata_QUICKWIN(obj: ContentMetadata_QUICKWIN): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentMetadata_QUICKWIN_internal(obj));
}
export function deserialize_ContentMetadata_QUICKWIN_internal(value: unknown): ParserResult<ContentMetadata_QUICKWIN> {
  return ((
    value: unknown,
  ): ParserResult<{
    common: ContentMetadataCommon;
    contentId: ContentId_QUICKWIN;
    contentType: "QUICKWIN";
    dataId: number;
    modifiedAt: DateTime<true>;
    quickWinType: QuickWinType;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/QuickWinMetadata]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/QuickWinMetadata]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "common")) {
      return { success: false, reason: `[#/components/schemas/QuickWinMetadata/common]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'common'.` };
    }
    const parsed_common = ((): ParserResult<ContentMetadataCommon> => {
      return ((value: unknown): ParserResult<ContentMetadataCommon> => {
        return deserialize_ContentMetadataCommon_internal(value);
      })(value["common"]);
    })();
    if (!parsed_common.success) {
      return { success: false, reason: parsed_common.reason };
    }
    if (!hasProp(value, "contentId")) {
      return { success: false, reason: `[#/components/schemas/QuickWinMetadata/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
    }
    const parsed_contentId = ((): ParserResult<ContentId_QUICKWIN> => {
      return ((value: unknown): ParserResult<ContentId_QUICKWIN> => {
        return deserialize_ContentId_QUICKWIN_internal(value);
      })(value["contentId"]);
    })();
    if (!parsed_contentId.success) {
      return { success: false, reason: parsed_contentId.reason };
    }
    if (!hasProp(value, "contentType")) {
      return { success: false, reason: `[#/components/schemas/QuickWinMetadata/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
    }
    const parsed_contentType = ((): ParserResult<"QUICKWIN"> => {
      return ((value: unknown): ParserResult<"QUICKWIN"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/QuickWinMetadata/contentType]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "QUICKWIN":
            return { success: true, value: "QUICKWIN" };
          default:
            return { success: false, reason: `[#/components/schemas/QuickWinMetadata/contentType]: '${value}' expected to be enum, one of 'QUICKWIN'.` };
        }
      })(value["contentType"]);
    })();
    if (!parsed_contentType.success) {
      return { success: false, reason: parsed_contentType.reason };
    }
    if (!hasProp(value, "dataId")) {
      return { success: false, reason: `[#/components/schemas/QuickWinMetadata/dataId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dataId'.` };
    }
    const parsed_dataId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/QuickWinMetadata/dataId]: '${value}' expected to be of type number.` };
      })(value["dataId"]);
    })();
    if (!parsed_dataId.success) {
      return { success: false, reason: parsed_dataId.reason };
    }
    if (!hasProp(value, "modifiedAt")) {
      return { success: false, reason: `[#/components/schemas/QuickWinMetadata/modifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modifiedAt'.` };
    }
    const parsed_modifiedAt = ((): ParserResult<DateTime<true>> => {
      return ((value: unknown): ParserResult<DateTime<true>> => {
        if (typeof value !== "number") {
          return { success: false, reason: `[#/components/schemas/QuickWinMetadata/modifiedAt]: '${value}' expected to be of type number.` };
        }
        const parsed = DateTime.fromMillis(value);
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/QuickWinMetadata/modifiedAt]: '${value}' expected to be valid DateTime.` };
        }
        return { success: true, value: parsed };
      })(value["modifiedAt"]);
    })();
    if (!parsed_modifiedAt.success) {
      return { success: false, reason: parsed_modifiedAt.reason };
    }
    if (!hasProp(value, "quickWinType")) {
      return { success: false, reason: `[#/components/schemas/QuickWinMetadata/quickWinType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'quickWinType'.` };
    }
    const parsed_quickWinType = ((): ParserResult<QuickWinType> => {
      return ((value: unknown): ParserResult<QuickWinType> => {
        return deserialize_QuickWinType_internal(value);
      })(value["quickWinType"]);
    })();
    if (!parsed_quickWinType.success) {
      return { success: false, reason: parsed_quickWinType.reason };
    }
    return {
      success: true,
      value: { common: parsed_common.value, contentId: parsed_contentId.value, contentType: parsed_contentType.value, dataId: parsed_dataId.value, modifiedAt: parsed_modifiedAt.value, quickWinType: parsed_quickWinType.value },
    };
  })(value);
}
export function deserialize_ContentMetadata_QUICKWIN(str: string): ParserResult<ContentMetadata_QUICKWIN> {
  return deserialize_ContentMetadata_QUICKWIN_internal(parseJsonWithNumbersAsBigint(str));
}
